import { Container, Row, Col } from "react-bootstrap";
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

export const ProblemSection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <section className="problem" id="problem" aria-labelledby="problem-heading">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}>
                  <h2 id="problem-heading">Cheap now. Expensive later.</h2>
                  <div className="problem-body">
                    <p>
                      You can spin up a site in 20 minutes with Lovable. You can pay a Fiverr freelancer $500 and have something live by Friday. The math looks great in the moment.
                    </p>
                    <p>Then twelve months pass.</p>
                    <p>
                      Your site doesn't rank. Leads don't convert. The AI-generated template you picked is sitting on 40,000 other businesses' homepages. The contact form is missing required ADA elements. The "SEO" your builder promised never showed up — because nobody set up structured data, AEO targeting, or LLM-readable content.
                    </p>
                    <p>
                      You feel like you wasted the money. So you put off fixing it. The leak gets worse.
                    </p>
                    <p className="problem-kicker">
                      That's the trap. Cheap web work isn't cheap. It's a tax you pay in lost leads every month — until you tear it down and build it right the first time.
                    </p>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
